import { finish, error } from '../../../modules/user/actions/reset-password';

import api from '../../../api';

export function request(dispatch, action) {
    api.post('/user/reset-password', {
        email: action.email,
        newPassword: action.newPassword,
        token: action.token
    }).then(
        ({ data }) => dispatch(finish(data)),
        ({ errors }) => dispatch(error(errors))
    );
}
